import { FOOTER, SHOW_FOOTER, SHOW_FOOTER_UI, HIDE_CHATBOT, UPDATE_CHATBOT, FOOTER_STREAM, MARKET_STATUS_START_LOADER, MARKET_STATUS_STOP_LOADER, } from "@redux/interfaces/IFooter";
import store from "../store";
var FooterActions = /** @class */ (function () {
    function FooterActions() {
        this.dispatch = store.dispatch;
    }
    FooterActions.prototype.getMarketStatus = function (FooterEntityList) {
        this.dispatch({
            type: FOOTER,
            payload: {
                data: FooterEntityList,
            },
        });
    };
    FooterActions.prototype.getMarketStatusStreaming = function (data) {
        this.dispatch({
            type: FOOTER_STREAM,
            payload: { streamData: data },
        });
    };
    FooterActions.prototype.updateShowMob_Menu = function (showFooter) {
        this.dispatch({
            type: SHOW_FOOTER,
            payload: { showFooter: showFooter },
        });
    };
    FooterActions.prototype.startLoader = function () {
        this.dispatch({
            type: MARKET_STATUS_START_LOADER,
        });
    };
    FooterActions.prototype.stopLoader = function () {
        this.dispatch({
            type: MARKET_STATUS_STOP_LOADER,
        });
    };
    FooterActions.prototype.setShowFooterUi = function (showFooterUi) {
        this.dispatch({
            type: SHOW_FOOTER_UI,
            payload: { showFooterUi: showFooterUi },
        });
    };
    FooterActions.prototype.updateChatBotState = function (chatBotState) {
        this.dispatch({
            type: UPDATE_CHATBOT,
            payload: { chatBotState: chatBotState },
        });
    };
    FooterActions.prototype.hideChatBot = function () {
        this.dispatch({
            type: HIDE_CHATBOT,
        });
    };
    return FooterActions;
}());
export default FooterActions;
